import React, { useState } from "react";
import { BrowserRouter as Router, withRouter } from "react-router-dom";
import "bootstrap";
import Accordion from "react-bootstrap/Accordion";
import dateFormat, { masks } from "dateformat";
import { leaseDateFormat } from "../../utils/utils";
class ParkingStorageSignage extends React.Component {
  constructor(props) {
    super(props);
    console.log(props);
    this.state = {
      parkingStorageSignage: this.props.parkingStorageSignage,
      parkingChargesApplicable: this.props.chargesApplicable,
    };
  }

  render() {
    return (
      <div className="tabHolder mb-4">
        <div className="row tabForm">
          <Accordion defaultActiveKey="0">
            {(this.state.parkingChargesApplicable == "yes" || this.state.parkingChargesApplicable == "hybrid" ) ? (
              Object.keys(this.state.parkingStorageSignage).map(function (
                key,
                index
              ) {
                return this.state.parkingStorageSignage[key].map(function (
                  pss,
                  index
                ) {
                  if (
                    this.state.parkingStorageSignage[key][index].chargeType ==
                      "Parking 2W" ||
                    this.state.parkingStorageSignage[key][index].chargeType ==
                      "Parking 4W" ||
                    this.state.parkingStorageSignage[key][index].chargeType ==
                      "Parking Other"
                  ) {
                    return (
                      <div className="container-fluid p-0">
                        <div className="row prospectAccordion">
                          <div className="col-lg-12 p-0">
                            <Accordion.Item eventKey={index}>
                              <Accordion.Header>
                                {`Period `}
                                {` `}
                                {pss.period}
                                {` `}
                                {`-`}
                                {` `}
                                {pss.chargeTypeText}
                                {` - `}
                                {`( Period Term - ${
                                  pss.periodTermYY == ""
                                    ? "0"
                                    : pss.periodTermYY
                                }Y -${
                                  pss.periodTermMM == ""
                                    ? "0"
                                    : pss.periodTermMM
                                }M -${
                                  pss.periodTermDD == ""
                                    ? "0"
                                    : pss.periodTermDD
                                }D )`}
                                {` - `}
                                {`From ${leaseDateFormat(pss.fromDate)}`}
                                {` `}
                                {`To ${leaseDateFormat(pss.toDate)}`}
                              </Accordion.Header>
                              <Accordion.Body>
                                <div className="container-fluid">
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            Period{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {pss.period}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            Charge Type{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {pss.chargeTypeText}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            From{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {leaseDateFormat(pss.fromDate)}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            To <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {leaseDateFormat(pss.toDate)}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            PKG Count{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {pss.count}
                                          </label>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            PKG Rate{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {pss.rate}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            PKG UOM{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {pss.uom}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            PKG Area{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {pss.area}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            PKG Due Date{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {pss.pkgDueDate}
                                            {`-`}
                                            {pss.pkgDueType}
                                            {`-`}
                                            {pss.pkgDueFrequency}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            PKG Rate Term{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {pss.rateTerm}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            PKG Frequency{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {pss.frequency}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    {
                                        typeof pss.freeParking != "undefined" && (
                                          <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            Free Parking
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {pss.freeParking}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                        )

                                    }
                                    

                                  </div>
                                </div>
                              </Accordion.Body>
                            </Accordion.Item>
                          </div>
                        </div>
                      </div>
                    );
                  } else if (
                    this.state.parkingStorageSignage[key][index].chargeType ==
                    "Storage"
                  ) {
                    return (
                      <div className="container-fluid p-0">
                        <div className="row prospectAccordion">
                          <div className="col-lg-12 p-0">
                            <Accordion.Item eventKey={index}>
                              <Accordion.Header>
                                {`Period `}
                                {` `}
                                {pss.period}
                                {` `}
                                {`-`}
                                {` `}
                                {pss.chargeTypeText}
                                {` - `}
                                {`( Period Term - ${
                                  pss.periodTermYY == ""
                                    ? "0"
                                    : pss.periodTermYY
                                }Y -${
                                  pss.periodTermMM == ""
                                    ? "0"
                                    : pss.periodTermMM
                                }M -${
                                  pss.periodTermDD == ""
                                    ? "0"
                                    : pss.periodTermDD
                                }D )`}
                                {` - `}
                                {`From ${leaseDateFormat(pss.fromDate)}`}
                                {` `}
                                {`To ${leaseDateFormat(pss.toDate)}`}
                              </Accordion.Header>
                              <Accordion.Body>
                                <div className="container-fluid">
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            Period{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {pss.period}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            Charge Type{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {pss.chargeTypeText}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            From{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {leaseDateFormat(pss.fromDate)}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            To <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {leaseDateFormat(pss.toDate)}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            Storage Type (STR){" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {pss.type}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            STR Name{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {pss.strName}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            STR Rate Type{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {pss.rateType}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            STR Rate{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {pss.rate}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            STR UOM{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {pss.uom}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            On Area{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {pss.onArea}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            STR Due Date{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {pss.strDueDate}
                                            {`-`}
                                            {pss.strDueType}
                                            {`-`}
                                            {pss.strDueFrequency}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            STR Rate Term{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {pss.rateTerm}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            STR Frequency{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {pss.frequency}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Accordion.Body>
                            </Accordion.Item>
                          </div>
                        </div>
                      </div>
                    );
                  } else if (
                    this.state.parkingStorageSignage[key][index].chargeType ==
                    "Signage"
                  ) {
                    return (
                      <div className="container-fluid p-0">
                        <div className="row prospectAccordion">
                          <div className="col-lg-12 p-0">
                            <Accordion.Item eventKey={index}>
                              <Accordion.Header>
                                {`Period `}
                                {` `}
                                {pss.period}
                                {` `}
                                {`-`}
                                {` `}
                                {pss.chargeTypeText}
                                {` - `}
                                {`( Period Term - ${
                                  pss.periodTermYY == ""
                                    ? "0"
                                    : pss.periodTermYY
                                }Y -${
                                  pss.periodTermMM == ""
                                    ? "0"
                                    : pss.periodTermMM
                                }M -${
                                  pss.periodTermDD == ""
                                    ? "0"
                                    : pss.periodTermDD
                                }D )`}
                                {` - `}
                                {`From ${leaseDateFormat(pss.fromDate)}`}
                                {` `}
                                {`To ${leaseDateFormat(pss.toDate)}`}
                              </Accordion.Header>
                              <Accordion.Body>
                                <div className="container-fluid">
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            Period{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {pss.period}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            Charge Type{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {pss.chargeTypeText}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            From{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {leaseDateFormat(pss.fromDate)}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            To <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {leaseDateFormat(pss.toDate)}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            Storage Type (SNG){" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {pss.type}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            SNG Name{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {pss.sngName}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            SNG Rate Type{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {pss.rateType}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            SNG Rate{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {pss.rate}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            SNG UOM{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {pss.uom}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            On Area{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {pss.onArea}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            SNG Due Date{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {pss.sngDueDate}
                                            {`-`}
                                            {pss.sngDueType}
                                            {`-`}
                                            {pss.sngDueFrequency}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            SNG Rate Term{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {pss.rateTerm}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            SNG Frequency{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {pss.frequency}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            SNG Location{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {pss.location}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Accordion.Body>
                            </Accordion.Item>
                          </div>
                        </div>
                      </div>
                    );
                  }
                },
                this);
              },
              this)
            ) : (
              <div className="container">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="inputContainer col-lg-12 col-md-12">
                      <div className="row mb-3">
                        <label className="col-sm-4 col-form-label">
                          Parking 2W <span className="astrik">*</span>
                        </label>
                        <label className="col-sm-7 col-form-label">
                          {this.props.parkingCharges
                            ? this.props.parkingCharges.parking2W
                            : 0}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="inputContainer col-lg-12 col-md-12">
                      <div className="row mb-3">
                        <label className="col-sm-4 col-form-label">
                          Parking 4W <span className="astrik">*</span>
                        </label>
                        <label className="col-sm-7 col-form-label">
                          {this.props.parkingCharges
                            ? this.props.parkingCharges.parking4W
                            : 0}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="inputContainer col-lg-12 col-md-12">
                      <div className="row mb-3">
                        <label className="col-sm-4 col-form-label">
                          Parking Other <span className="astrik">*</span>
                        </label>
                        <label className="col-sm-7 col-form-label">
                          {this.props.parkingCharges
                            ? this.props.parkingCharges.parkingOther
                            : 0}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Accordion>
          {/* {this.state.parkingChargesApplicable == "yes" && ( */}
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-6">
                  <div className="inputContainer col-lg-12 col-md-12">
                    <div className="row mb-3">
                      <label className="col-sm-4 col-form-label">
                        Notes
                        <span className="astrik">*</span>
                      </label>
                      <label className="col-sm-7 col-form-label">
                        {this.props.parkingNotes}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          {/* )} */}
        </div>
      </div>
    );
  }
}
export default withRouter(ParkingStorageSignage);
